import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'settings-parking-passes-lots-list',
    templateUrl: './settings-parking-passes-lots-list.component.html',
    styleUrls: ['./settings-parking-passes-lots-list.component.scss']
})
export class SettingsParkingPassesLotsListComponent {

    constructor(
        public urlService: UrlService,
        public settingsParkingPassesService: SettingsParkingPassesService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsParkingPassesService.parkingPassesData.lots.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        if (checked && this.settingsParkingPassesService.selectedItemData) {
            this.settingsParkingPassesService.toggleDetailedView(null, false);
        } else {
            selectedItem.checked = true;
            this.settingsParkingPassesService.selectedItemData = null;
            setTimeout(() => this.settingsParkingPassesService.toggleDetailedView(selectedItem, true));
        }
    }

    uncheckItem(): void {
        this.settingsParkingPassesService.parkingPassesData.lots.data.forEach((item) => item.checked = false);
    }

    deleteParkingLot(item, event): void {
        event.stopPropagation();
        this.settingsParkingPassesService.deleteParkingLot(item);
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsParkingPassesService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes-lots-list/settings-parking-passes-lots-list.component.ts